<script setup lang="ts">
import { ref } from 'vue'
import PrimeMenu, { type MenuMethods } from 'primevue/menu'

type MenuModelItem = {
  label?: string
  icon?: string
  command?: () => void
  url?: string
  to?: string
  disabled?: boolean
  visible?: boolean
  separator?: boolean
  items?: MenuModelItem[]
}

interface Props {
  /** Item descriptors (PrimeVue MenuItem model). */
  model: MenuModelItem[]
  /** Render attached to an anchor via `show(event)` rather than inline. */
  popup?: boolean
}

defineProps<Props>()

const menuRef = ref<MenuMethods | null>(null)

defineExpose({
  show: (event: Event, target?: HTMLElement) => menuRef.value?.show(event, target),
  hide: () => menuRef.value?.hide(),
  toggle: (event: Event, target?: HTMLElement) => menuRef.value?.toggle(event, target),
})
</script>

<template>
  <PrimeMenu ref="menuRef" :model="model" :popup="popup" />
</template>
